<template>
  <div class="otherHome">
    <el-aside style="overflow: hidden; width: 14%">
      <div class="other-title">船员服务管理平台</div>
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo other-menu"
        @open="handleOpen"
        background-color="#0E0D4B"
        text-color="#FFFFFF"
        active-text-color="#FFFFFF"
        :unique-opened="true"
        router
        @close="handleClose"
      >
        <div v-for="(item, index) in menuList" :key="index">
          <el-menu-item
            :index="item.path"
            v-if="!item.childs.length"
            :class="
              item.childsPath.indexOf(currentPath) > -1 ? 'is-active' : ''
            "
          >
            <span class="other-spanIcon"
              ><i
                v-if="item.icon"
                class="iconfont other-icon"
                :class="item.icon"
              ></i
            ></span>
            <span style="margin-left: 12px">{{ item.name }}</span></el-menu-item
          >
          <el-submenu
            :index="item.path"
            v-if="item.childs.length"
            class="custom-submenu"
          >
            <template slot="title">
              <span class="other-spanIcon"
                ><i
                  v-if="item.icon"
                  class="iconfont other-icon"
                  :class="item.icon"
                ></i
              ></span>
              <span style="margin-left: 12px">{{ item.name }}</span>
            </template>
            <el-menu-item-group v-if="item.childs">
              <el-menu-item
                v-for="(val, i) in item.childs"
                :key="i"
                :index="val.path"
                :class="
                  val.childsPath.indexOf(currentPath) > -1 ? 'is-active' : ''
                "
              >
                <span style="margin-left: 22px">{{
                  val.name
                }}</span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
        </div>
      </el-menu>
    </el-aside>
    <el-main style="overflow: hidden; padding: 0">
      <div class="other-login">
        <!-- <span v-if="!routeChild">{{ routeName }}</span>
        <span v-if="routeChild">
          <span style="color: #9e9e9e">{{ routeName }}</span>
          <span style="margin: 0 4px">/</span>
          <span>{{ crewName }}</span>
        </span> -->
        <el-breadcrumb class="elBreadcrumb" separator="/">
          <el-breadcrumb-item
            v-for="(item, index) in routeInfoList"
            :key="index"
            :class="
              index != routeInfoList.length - 1 ? 'elBreadGray' : 'elBreadBlack'
            "
            :to="item.path"
            >{{ item.title ? item.title : item.meta.title }}</el-breadcrumb-item
          >
        </el-breadcrumb>
        <!-- <span>{{ routeName }}</span> -->
        <div class="other-homeImg">
          <!-- <img :src="imageUrl" alt="" /> -->
          <!-- <img v-if="userType == 4" src="@/assets/owner-user.png" alt="" /> -->

          <el-dropdown
            @command="handleCommand"
            v-if="userName"
            class="drop-width"
          >
            <span class="el-dropdown-link" :title="userName">
              {{ userName }}<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b">企业信息</el-dropdown-item>
              <el-dropdown-item command="a">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <router-view :key="$route.path"></router-view>
    </el-main>
  </div>
</template>
<script>
import "@/iconfont/iconfont.css";
import { removeStorage } from "@/utils/auth";
import router from "@/router";
import { getBaseInfo, getOneFile } from "@/apis/index";
const menuList = [
  {
    name: "船员库",
    path: "/otherHome",
    childs: [],
    isShow: "1",
    icon: "icon-renyuan",
    isEffective: true,
    pid: "0",
    childsPath: ["/crewDetail", "/addCrew"],
  },
  {
    name: "待选人才",
    pid: "1",
    path: "selectedCrew",
    icon: "icon-renyuanguanli",
    childsPath: [],
    childs: [
      {
        name: "邀请船员",
        path: "/inviteCrew",
        childsPath: ["/inviteCrew", "/inviteDetail", "/inviteAdd"],
      },
      {
        name: "投递船员",
        path: "/deliveryCrew",
        childsPath: ["/deliveryCrew", "/inviteDetail2"],
      },
      {
        name: "未通过",
        path: "/unpassCrew",
        childsPath: ["/unpassCrew", "/inviteDetail3"],
      },
    ],
  },
  {
    name: "职位管理",
    pid: "2",
    path: "/positionManagement",
    icon: "icon-chuanyuan",
    childsPath: [],
    childs: [
      {
        name: "招聘中",
        path: "/progressIn",
        childsPath: ["/progressIn", "/addCrewJob", "/crewPass"],
      },
      {
        name: "已下线",
        path: "/offlineOver",
        childsPath: ["/offlineOver", "/addCrewJob2", "/crewPass2"],
      },
    ],
  },
  {
    name: "费用薪资",
    pid: "2",
    path: "/salaryList",
    icon: "icon-feiyong",
    childsPath: [],
    childs: [
      {
        name: "劳务薪资",
        path: "/laborSalary",
        childsPath: [],
      },
      {
        name: "劳务费用",
        path: "/laborCosts",
        childsPath: [],
      },
      {
        name: "节能考核",
        path: "/energySaving",
        childsPath: [],
      },
      {
        name: "优秀船员奖励",
        path: "/excellentCrew",
        childsPath: [],
      },
      {
        name: "其他奖励",
        path: "/otherRewards",
        childsPath: [],
      },
      {
        name: "船舶考核",
        path: "/shipAudit",
        childsPath: [],
      },
      {
        name: "外来人员客餐费",
        path: "/crewFood",
        childsPath: [],
      },
    ],
  },
  {
    name: "劳保用品",
    pid: "3",
    path: "/laborList",
    icon: "icon-feiyong",
    childsPath: [],
    childs: [
      {
        name: "新建申请",
        path: "/applyAdd",
        childsPath: [],
      },
      {
        name: "我的申请",
        path: "/laborApplyList",
        childsPath: [],
      },
      {
        name: "我的审批",
        path: "/laborPassList",
        childsPath: [],
      },
    ],
  },
];
export default {
  data() {
    return {
      menuList,
      activeIndex: "",
      userName: "",
      userType: "",
      routeName: "",
      routeChild: false,
      crewName: "xx",
      routeInfoList: router.globalData.routeInfoList,
      currentPath: "",
      imageUrl: "",
    };
  },
  mounted() {
    // this.changeTextBasedOnRoute();
    this.getUser();
    // this.getBaseInfoList();
  },
  // created() {
  //   this.$nextTick(() => {
  //     this.generateBreadcrumb();
  //   });
  // },
  watch: {
    $route(newValue) {
      // this.changeTextBasedOnRoute();
      this.routeInfoList = router.globalData.routeInfoList;
      this.currentPath = newValue.path;
      console.log(newValue);
      this.currentPath = "/" + this.currentPath.split("/")[1];
      console.log(this.currentPath);
    },
  },
  methods: {
    handleOpen(info) {
      this.activeIndex = info.path;
    },
    handleClose() {},
    generateBreadcrumb() {
      // const matched = this.$route.matched;
      console.log("wwwww");
      // 初始化面包屑导航数据
      // const breadcrumbList = [];
      // // 遍历路由信息，生成面包屑导航数据
      // matched.forEach((item) => {
      //   const { meta, name, path } = item;
      //   if (meta.breadcrumb) {
      //     breadcrumbList.push({
      //       name,
      //       path,
      //       title: meta.title,
      //       meta: meta,
      //     });
      //   }
      // });
      // breadcrumbList[0].path = "/dataProfiling";
      // this.breadcrumbList = breadcrumbList;
    },
    async getBaseInfoList() {
      let companyId = sessionStorage.getItem("companyId");
      const res = await getBaseInfo({ companyId: companyId });
      this.lookFileSrc(res.data.logo, 1);
    },
    async lookFileSrc(src, type) {
      // console.log(src);
      let url = await getOneFile({
        fileName: src[0] == "/" ? "file" + src : "file/" + src,
      });
      if (type == 1) {
        this.imageUrl = url.data;
      }
    },
    handleCommand(command) {
      if (command == "a") {
        removeStorage();
        this.userName = "";
        this.userType = "";
        this.$router.push("/home");
      }
      if (command == "b") {
        this.$router.push("/companyDetail");
      }
    },
    getUser() {
      this.userName = sessionStorage.getItem("loginName");
      let postName = sessionStorage.getItem("postName");
      this.userType = sessionStorage.getItem("userType");
      if (postName) {
        // console.log();
        // console.log(postName.indexOf(":"));
        if (postName.indexOf(":") > -1) {
          postName = postName.split(":")[1];
          this.userName = postName;
        } else {
          this.userName = postName;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.otherHome {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: space-between;
}
.other-menu {
  height: 100%;
  font-weight: 600;
}
.other-title {
  width: 99.6%;
  height: 51px;
  line-height: 51px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  background-color: #0e0d4b;
}
.el-menu-item-group__title {
  display: none;
}
.custom-submenu .el-menu {
  background-color: #0a0c40 !important;
}
.el-menu-item.is-active,
// .el-submenu.is-active > .el-submenu__title {
//   background-color: #383d68 !important; /* 这里是您想要的背景颜色 */
// }
.el-submenu.is-active:not(.is-root) > .el-submenu__title {
  background-color: #383d68 !important; /* 这里是您想要的背景颜色 */
}
.other-login {
  height: 46px;
  line-height: 46px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 0 11px;
  display: flex;
  justify-content: space-between;
}
.other-login span:nth-child(1) {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1b1e1f;
}
.other-icon {
  font-size: 12px;
  font-weight: 500;
  color: #ffffff !important;
}
.other-spanIcon {
  background: #4d4e7c;
  border-radius: 2px;
  padding: 1px 4px;
}
.other-homeImg {
  display: flex;
}
.other-homeImg img {
  width: 22px;
  height: 22px;
  margin-top: 12px;
  margin-right: 10px;
}
</style>
